import store from "@/store";

export function buildClientId(userId) {
	return String(userId ?? "");
}

export function buildMercureSubscribePayload() {
	return { profile: "user" };
}

export function buildSseTopics(userId) {
	const base = store.state.config.sseTopicBase;
	if (!base || !userId) {
		return [];
	}

	return [`${base}/user/${userId}`];
}
